import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import { SuspenseRouter as Router } from "./SuspenseRouter";
import { Provider } from "react-redux";

import App from "./App";

import "./assets/css/main.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles.scss";
import "flatpickr/dist/flatpickr.min.css";
import { store } from "./store";
import { getMode, recaptchaKey } from "./settings";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

const APP_VERSION = process.env.REACT_APP_CURRENT_GIT_SHA || "";

if (localStorage.getItem("APP_VERSION") != APP_VERSION) {
  localStorage.clear();
  localStorage.setItem("APP_VERSION", APP_VERSION);
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const mode = getMode();

const Container = mode === "production" ? GoogleReCaptchaProvider : "div";
const containerProps = (mode === "production"
  ? {
      container: { parameters: { badge: "bottomleft" } },
      reCaptchaKey: recaptchaKey,
    }
  : {}) as unknown as Parameters<typeof GoogleReCaptchaProvider>[0];
root.render(
  <Provider store={store}>
    <Container {...containerProps}>
      <Router>
        <Suspense fallback={<div></div>}>
          <App />
        </Suspense>
      </Router>
    </Container>
  </Provider>
);
